import { getApi } from '../../utils/api'

export function getFieldVariables({ entity, options }) {
  return getApi({
    endpoint: 'api/text-module/field-variables/',
    options,
    params: { entity },
  })
}
